import React, { useEffect, useState } from 'react';
// import '@style/modules/analysis/esg.scss';
import '../../../../styles/modules/analysis/esg.scss';
import { Checkbox } from 'antd';

const ScoreTag = ({ score, v25, v75 }) => (
  <>
    {score === 0 ? (
      <div className="esg-tag-null">N/A</div>
    ) : score > v75 ? (
      <div className="esg-tag-above">Above Average</div>
    ) : score > v25 ? (
      <div className="esg-tag-average">Industry Average</div>
    ) : (
      <div className="esg-tag-below">Below Average</div>
    )}
  </>
);

const ScoreBar = ({ role, name, mean = 0, point1, point2, point3, point4 }) => {
  if (mean === 0) {
    return (
      <>
        <div className="rating" key={role}>
          <div className="role-text">{role}</div>
          <div className="esg-company-name">{name}</div>
          <ScoreTag score={mean} v25={point2} v75={point3} />
        </div>
        <div className="color-indicator">
          <div className="label-mark" />
          <div className="colors-pannel">
            <div className="grey-side" />
            <div className="grey-center" />
            <div className="grey-side" />
          </div>
          <div className="colors-label">
            <div className="label-left">Below Average</div>
            <div className="label-center">Industry Average</div>
            <div className="label-right">Above Average</div>
          </div>
        </div>
      </>
    );
  }

  mean = mean > point4 ? point4 : mean;
  mean = mean < point1 ? point1 : mean;
  const position = ((mean - point1) / (point4 - point1)) * 100;

  return (
    <>
      <div className="rating" key={role}>
        <div className="role-text">{role}</div>
        <div className="esg-company-name">{name}</div>
        <ScoreTag score={mean} v25={point2} v75={point3} />
      </div>
      <div className="color-indicator">
        <div className="label-mark">
          <div style={{ width: `${position}%` }} />
          {mean > point3 ? (
            <span
              className="appkiticon icon-downtrend-fill a-font-10"
              style={{ color: '#006CE2' }}
            />
          ) : mean > point2 ? (
            <span
              className="appkiticon icon-downtrend-fill a-font-10"
              style={{ color: '#FFB600' }}
            />
          ) : (
            <span
              className="appkiticon icon-downtrend-fill a-font-10"
              style={{ color: '#D04A02' }}
            />
          )}
        </div>
        <div className="colors-pannel">
          <div className="orange" />
          <div className="yellow" />
          <div className="blue" />
        </div>
        <div className="label-left">Below Average</div>
        <div className="label-center">Industry Average</div>
        <div className="label-right">Above Average</div>
      </div>
    </>
  );
};

export const EditableScoreBar = ({
  onChange = () => {},
  onNotApplicableChange = () => {},
  isEditable,
  mean,
  point1,
  point4,
  isOverallNotApplicable,
  ...props
}) => {
  const [value, setValue] = useState(mean);
  const [mouseIsDown, setMouseIsDown] = useState(false);

  useEffect(() => {
    setValue(mean);
  }, [mean]);

  const getValueFromEvent = (e, rect) =>
    ((e.clientX - rect.left) / rect.width) * (point4 - point1) + point1;

  const handleMouseDown = (e) => {
    const rect = e.target.getBoundingClientRect();
    setMouseIsDown(true);
    setValue(getValueFromEvent(e, rect));
  };

  const handleMouseMove = (e) => {
    const rect = e.target.getBoundingClientRect();
    if (!mouseIsDown) {
      return;
    }
    setValue(getValueFromEvent(e, rect));
  };

  const afterChange = () => {
    setMouseIsDown(false);
    onChange(parseFloat(value.toFixed(1)));
  };

  const handleCheckboxChange = (e) => {
    onNotApplicableChange(e.target.checked);
  };

  return (
    <div className="editable-wrapper" key={props.key}>
      <div
        className="mouse-event-collector"
        onMouseDown={handleMouseDown}
        onMouseUp={afterChange}
        onMouseMove={handleMouseMove}
        onMouseLeave={afterChange}
        style={{
          display: isOverallNotApplicable || !isEditable ? 'none' : 'block',
        }}
      />
      {isEditable ? (
        <div className="not-applicable-cb">
          <Checkbox
            checked={isOverallNotApplicable}
            onChange={handleCheckboxChange}
          />
          <span>Not Applicable</span>
        </div>
      ) : null}
      <ScoreBar
        {...props}
        point1={point1}
        point4={point4}
        mean={isOverallNotApplicable ? 0 : value}
      />
    </div>
  );
};

export default ScoreBar;
